<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{$ml.get('shared.retailSale')}}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{$ml.get('shared.dashboard')}}</span>
        </li>
        <li>
          <i class="fa fa-cogs"></i>
          <span>{{$ml.get('shared.diningHall')}}</span>
        </li>
        <li>
          <span>{{$ml.get('shared.retailSale')}}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-4" @click="setCardFocus()">
          <div class="box box-primary">
            <div class="box-header">
              <h3 class="box-title">
                <span>Kart Numarası</span>
              </h3>
            </div>
            <div class="box-body">
              <input
                id="searchCardNumber"
                type="text"
                class="form-control input-lg"
                v-model="cardNumber"
                @change="searchEmployee()"
              />
            </div>
          </div>
          <div class="box box-primary">
            <div class="box-header">
              <h3 class="box-title">
                <span>{{$ml.get("employees.employeeInfo")}}</span>
              </h3>
            </div>
            <div class="box-body">
              <img
                class="profile-user-img img-responsive img-circle"
                :src="(employee.image == null) ? '/src/assets/default-user.png' : employee.image"
                style="height:150px;width:150px;"
              />
              <div class="form-group">
                <label>{{$ml.get('employees.nameSurname')}}</label>
                <label class="form-control">
                  <span v-show="employee.sicilNo">{{employee.sicilNo}} -</span>
                  {{employee.name}}
                </label>
              </div>
              <div class="form-group">
                <label>{{$ml.get('employees.department')}}</label>
                <label class="form-control">{{employee.department}}</label>
              </div>
              <div class="form-group">
                <label>{{$ml.get('employees.title')}}</label>
                <label class="form-control">{{employee.title}}</label>
              </div>
              <div class="form-group">
                <label>{{$ml.get('foodGroupOperations.availableBalance')}}</label>
                <label v-text="employee.credit" class="form-control"></label>
              </div>
              <div class="overlay" id="load" :hidden="!isLoading">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
            </div>
          </div>
          <button
            data-toggle="modal"
            data-target="#report"
            class="btn btn-primary btn-lg"
            style="width:100%;"
          >
            <i class="fa fa-file-text"></i> Rapor Görüntüle
          </button>
        </div>
        <div class="col-sm-8">
          <div class="row" style="margin:10px 0 10px 0;">
            <div class="col-sm-6">
              <button
                @click="activeScreen = 0"
                :class="activeScreen == 0 ? 'btn btn-primary btn-lg' : 'btn btn-danger btn-lg'"
                style="width:100%;height:50px;"
              >Satış</button>
            </div>
            <div class="col-sm-6">
              <button
                @click="activeScreen = 1"
                :class="activeScreen == 1 ? 'btn btn-primary btn-lg' : 'btn btn-danger btn-lg'"
                style="width:100%;height:50px;"
              >Geçmiş Satışlar (Bu Ay)</button>
            </div>
          </div>
          <div class="row" v-show="activeScreen == 0">
            <div class="col-sm-12" style="margin-bottom:20px;">
              <input
                id="totalPrice"
                type="number"
                min="0"
                v-model="total"
                class="form-control input-lg text-center text-bold text-black"
                style="font-size:20px;background-color:#ffd110;"
              />
            </div>
            <div class="col-sm-4">
              <button class="btn number-btn" @click="setPaymentNumber(1)">1</button>
            </div>
            <div class="col-sm-4">
              <button class="btn number-btn" @click="setPaymentNumber(2)">2</button>
            </div>
            <div class="col-sm-4">
              <button class="btn number-btn" @click="setPaymentNumber(3)">3</button>
            </div>
            <div class="col-sm-4">
              <button class="btn number-btn" @click="setPaymentNumber(4)">4</button>
            </div>
            <div class="col-sm-4">
              <button class="btn number-btn" @click="setPaymentNumber(5)">5</button>
            </div>
            <div class="col-sm-4">
              <button class="btn number-btn" @click="setPaymentNumber(6)">6</button>
            </div>
            <div class="col-sm-4">
              <button class="btn number-btn" @click="setPaymentNumber(7)">7</button>
            </div>
            <div class="col-sm-4">
              <button class="btn number-btn" @click="setPaymentNumber(8)">8</button>
            </div>
            <div class="col-sm-4">
              <button class="btn number-btn" @click="setPaymentNumber(9)">9</button>
            </div>
            <div class="col-sm-4">
              <button
                class="btn number-btn"
                style="font-size:20px;background-color:#ffd110;"
                @click="clearPaymentNumber()"
              >
                <i class="fa fa-arrow-left text-black"></i>
              </button>
            </div>
            <div class="col-sm-4">
              <button class="btn number-btn" @click="setPaymentNumber(0)">0</button>
            </div>
            <div class="col-sm-2">
              <button class="btn number-btn" @click="setPaymentNumber('.0')">
                <i class="fa fa-circle" style="font-size:15px;"></i>
              </button>
            </div>
            <div class="col-sm-2">
              <button
                class="btn number-btn bg-red"
                style="font-size:20px;"
                @click="setPaymentReset()"
              >
                <i class="fa fa-trash"></i>
              </button>
            </div>
            <div class="col-sm-12">
              <button
                @click="question()"
                class="btn btn-primary btn-lg"
                style="width:100%;height:100px;margin-top:10px;"
              >BAKİYEDEN DÜŞ</button>
            </div>
          </div>
          <div class="row" v-show="activeScreen == 1">
            <div class="col-sm-12">
              <div class="box box-primary">
                <div class="box-header">
                  <h3 class="box-title">
                    <span>Satışlar</span>
                  </h3>
                </div>
                <div class="box-body">
                  <div
                    v-show="saleList != null"
                    class="table-responsive no-padding"
                    :style="windowReportHeightSize"
                  >
                    <table class="table" style="font-size:14px;" id="printExcel">
                      <thead>
                        <tr>
                          <th class="text-left">İşlem Zamanı</th>
                          <th class="text-left">Tutar</th>
                          <th class="text-left"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="sale in saleList" :key="sale.id">
                          <td>{{sale.date}}</td>
                          <td class="text-left">{{sale.price}} TL</td>
                          <td class="text-left">
                            <button @click="selectSale(sale)" class="btn btn-danger btn-sm">
                              <i class="fa fa-undo"></i> İade Oluştur
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-show="saleList == null || saleList == 0" class="callout callout-info">
                    <i class="fa fa-info-circle"></i>
                    {{$ml.get('dashboard.fastReportNotRecord')}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- /.MODAL START-->
    <div class="modal fade" id="report">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <button
              @click="exportToExcel()"
              type="button"
              class="btn btn-sm btn-success pull-right"
            >
              <i class="fa fa-share"></i>
              {{$ml.get('general.exportToExcel')}}
            </button>
            <button @click="exportToPDF()" type="button" class="btn btn-sm btn-danger pull-right">
              <i class="fa fa-share"></i>
              {{$ml.get('general.exportToPdfOrPrint')}}
            </button>
            <div
              class="pull-left"
              style="margin-right:10px;font-size:20px;"
              :hidden="!isLoadingReport"
            >
              <i class="fa fa-refresh fa-spin"></i>
            </div>
            <h4 class="modal-title">
              <span>Satış Raporu</span>
            </h4>
          </div>
          <div class="modal-body">
            <div class="row" style="margin-bottom:5px;">
              <div class="col-sm-4">
                <div class="form-group">
                  <label>Başlangıç Tarihi</label>
                  <input type="datetime-local" class="form-control" v-model="startDate" />
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label>Bitiş Tarihi</label>
                  <input type="datetime-local" class="form-control" v-model="endDate" />
                </div>
              </div>
              <div class="col-sm-4">
                <button
                  class="btn btn-primary"
                  style="margin-top:15px;width:100%;"
                  @click="getReport()"
                >
                  <i class="fa fa-search"></i> Görüntüle
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div
                  id="printReport"
                  v-show="reportDataList != null"
                  class="table-responsive no-padding"
                  :style="windowReportHeightSize"
                >
                  <div
                    v-show="reportDataList != null && reportDataList != 0"
                    class="dep-baslik"
                    style="padding-bottom:10px;padding-top:10px; text-align:center;"
                  >
                    <span class="mb-10 text-center">{{reportName}}</span>
                  </div>
                  <table class="table" style="font-size:14px;" id="printExcel">
                    <thead>
                      <tr>
                        <th class="text-left">İşlem Zamanı</th>
                        <th class="text-left">Tutar</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(report, index) in reportDataList" :key="index">
                        <td>{{report.date}}</td>
                        <td class="text-left">{{report.price}} TL</td>
                      </tr>
                      <tr v-show="reportDataList != null && reportDataList != 0">
                        <td class="text-right text-bold">Toplam :</td>
                        <td class="text-bold text-left">{{reportDataTotal}} TL</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  v-show="reportDataList == null || reportDataList == 0"
                  class="callout callout-info"
                >
                  <i class="fa fa-info-circle"></i>
                  {{$ml.get('dashboard.fastReportNotRecord')}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /.MODAL END -->
    <!-- /.MODAL START-->
    <div class="modal fade" id="question">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content modal-primary">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title text-center">
              <span style="font-size:25px;">Onay</span>
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div
                class="col-sm-12"
                style="text-align:center;padding:10px;margin-bottom:20px;font-size:25px;"
              >
                <span>
                  {{employee.sicilNo}} - {{employee.name}}
                  <br />
                  <br />kişinin bakiyesinden
                  <strong>{{total}} TL</strong> tutar düşülecektir.
                  <br />
                  <br />Onaylıyor musunuz?
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <button
                  @click="setPayment()"
                  class="btn btn-success"
                  style="padding:20px;font-size:30px;width:100%;"
                >
                  <i class="fa fa-check"></i>
                  <br />Evet
                </button>
              </div>
              <div class="col-sm-6">
                <button
                  data-dismiss="modal"
                  class="btn btn-danger"
                  style="padding:20px;font-size:30px;width:100%;"
                >
                  <i class="fa fa-remove"></i>
                  <br />Hayır
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /.MODAL END -->
    <!-- /.MODAL START-->
    <div class="modal fade" id="refund-confirm-modal">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content modal-primary">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title text-center">
              <span style="font-size:25px;">Onay</span>
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div
                class="col-sm-12"
                style="text-align:center;padding:10px;margin-bottom:20px;font-size:25px;"
              >
                <span>
                  {{employee.sicilNo}} - {{employee.name}}
                  <br />
                  <br />
                  kişinin {{selectedSale.date}} tarihli satışından
                  <strong>{{selectedSale.price}} TL</strong> tutar iade edilecektir.
                  <br />
                  <br />Onaylıyor musunuz?
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <button
                  @click="refund(selectedSale.id)"
                  class="btn btn-success"
                  style="padding:20px;font-size:30px;width:100%;"
                >
                  <i class="fa fa-check"></i>
                  <br />Evet
                </button>
              </div>
              <div class="col-sm-6">
                <button
                  data-dismiss="modal"
                  class="btn btn-danger"
                  style="padding:20px;font-size:30px;width:100%;"
                >
                  <i class="fa fa-remove"></i>
                  <br />Hayır
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /.MODAL END -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      isLoading: false,
      isLoadingReport: false,
      windowHeight: window.innerHeight,
      activeScreen: 0,
      sales: [],
      selectedSale: {
        id: null,
        date: "",
        price: 0
      },
      employee: {
        id: null,
        sicilNo: "",
        name: "",
        title: "",
        department: "",
        image: null,
        credit: 0,
        cardNumber: ""
      },
      total: 0,
      cardNumber: "",
      startDate: null,
      endDate: null,
      reportName: "",
      /*reportData: {
        total,
        data: [{ date: 11, price: 0 }]
      },*/
      reportDatas: [],
      reportDataTotal: 0
    };
  },
  filters: {
    toDateFormatGet(str, format) {
      if (!str) {
        return "";
      }
      if (format == "gg.aa.yyyy ss:dd") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return gun + "." + ay + "." + yil;
      } else if (format == "ss:dd:ss") {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye =
          str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    }
  },
  computed: {
    activeUser() {
      return this.$store.getters.getUser;
    },
    saleList() {
      return this.sales;
    },
    reportDataList() {
      return this.reportDatas;
    },
    windowReportHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 180;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    exportToPDF() {
      this.$htmlToPaper("printReport");
    },
    exportToExcel() {
      var tarih = new Date();
      var filename = this.reportTitle + " - " + tarih.toLocaleString();
      $("#printExcel").table2excel({
        filename: filename + ".xls",
        preserveColors: true
      });
    },
    clearEmployee() {
      this.employee.id = null;
      this.employee.sicilNo = "";
      this.employee.name = "";
      this.employee.title = "";
      this.employee.department = "";
      this.employee.image = null;
      this.employee.credit = 0;
      this.employee.cardNumber = "";
      this.cardNumber = "";
    },
    async searchEmployee() {
      if (this.cardNumber.length == 10) {
        try {
          this.isLoading = true;
          var cardNo = this.cardNumber;
          const response = await this.$axios
            .get("/Sale/GetEmployeeByCardNumber?cardNumber=" + this.cardNumber)
            .then(response => {
              this.employee = response.data;
              this.employee.cardNumber = cardNo;
              this.cardNumber = "";
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                } else if (error.response.status == 404) {
                  alertify.error("Kişi Bulunamadı");
                  this.clearEmployee();
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.clearEmployee();
                  this.isLoading = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.clearEmployee();
                  this.isLoading = false;
                  return;
                }
              }
            });
          await this.getSales();
          this.isLoading = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
        }
      }
    },
    question() {
      if (this.employee.id == null) {
        alertify.warning(this.$ml.get("alerts.noContactInformation"));
        return;
      }
      if (this.total == null || this.total == 0) {
        alertify.warning(this.$ml.get("alerts.pleaseEnterAmount"));
        return;
      }
      var credit = parseFloat(this.employee.credit);
      var total = parseFloat(this.total);
      if (credit < total) {
        alertify.warning(this.$ml.get("alerts.insufficientBalance"));
        return;
      }
      $("#question").modal("show");
    },
    setCardFocus() {
      $("#searchCardNumber").focus();
    },
    async setPayment() {
      try {
        if (this.employee.id == null) {
          alertify.warning(this.$ml.get("alerts.noContactInformation"));
          return;
        }
        if (this.total == null || this.total == 0) {
          alertify.warning(this.$ml.get("alerts.pleaseEnterAmount"));
          return;
        }
        var credit = parseFloat(this.employee.credit);
        var total = parseFloat(this.total);
        if (credit < total) {
          alertify.warning(this.$ml.get("alerts.insufficientBalance"));
          return;
        }
        const response = await this.$axios
          .post("/Sale", {
            employeeId: this.employee.id,
            price: this.total
          })
          .then(response => {
            if (response.status == 200) {
              $("#question").modal("hide");
              alertify.success("İşlem Başarılı!");
              this.clearEmployee();
              this.total = 0;
              this.isLoading = false;
              this.setCardFocus();
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
              if (error.response.status == 500) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası : " + error.message);
      }
    },
    setPaymentReset() {
      this.total = 0;
    },
    clearPaymentNumber() {
      var num = String(this.total);
      var aa = num.slice(0, -1);
      if (aa == "") {
        this.total = 0;
      } else if (
        aa.substr(aa.length - 1, 1) == "," ||
        aa.substr(aa.length - 1, 1) == "."
      ) {
        this.total = aa.slice(0, -1);
      } else {
        this.total = aa;
      }
    },
    setPaymentNumber(number) {
      var index = String(this.total).indexOf(".0");
      var num = "";
      if (this.total == 0) {
        num = String(number);
      } else if (index != -1) {
        num =
          String(this.total).substr(0, this.total.length - 1) + String(number);
      } else {
        num = String(this.total) + String(number);
      }
      this.total = num;
      $("#totalPrice").focus();
    },
    async getReport() {
      if (
        this.startDate == null ||
        this.endDate == null ||
        this.startDate > this.endDate
      ) {
        alertify.warning(this.$ml.get("alerts.invalidDate"));
        return;
      }
      try {
        this.isLoadingReport = true;
        this.reportDatas = [];
        const response = await this.$axios
          .post("/Sale/Report", {
            startDate: this.startDate,
            endDate: this.endDate
          })
          .then(response => {
            this.reportDatas = response.data.data;
            this.reportDataTotal = response.data.total;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingReport = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingReport = false;
                return;
              }
            }
          });
        this.reportName =
          this.activeUser.userName +
          " - Bakiye İcmal Raporu" +
          " (" +
          this.toDateFormat(this.startDate, "gg.aa.yyyy ss:dd") +
          " - " +
          this.toDateFormat(this.endDate, "gg.aa.yyyy ss:dd") +
          ")";
        this.isLoadingReport = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoadingReport = false;
      }
    },
    async refund(id) {
      if (!id) {
        alertify.warning(this.$ml.get("alerts.pleaseSelect"));
      } else {
        this.isLoadingReader = true;
        try {
          const response = await this.$axios
            .delete("/Sale/" + id)
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingReader = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingReader = false;
                  return;
                }
              }
            });
          $("#refund-confirm-modal").modal("hide");
          this.cardNumber = this.employee.cardNumber;
          await this.searchEmployee();
          alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
          this.isLoadingReader = false;
        } catch (error) {
          alertify.error("Hata Oluştu : " + error);
          this.isLoadingReader = false;
        }
      }
    },
    selectSale(sale) {
      this.selectedSale = sale;
      $("#refund-confirm-modal").modal("show");
    },
    async getSales() {
      if (this.employee.id == null) {
        alertify.warning(this.$ml.get("alerts.noContactInformation"));
        return;
      }
      try {
        this.isLoading = true;
        var sales = [];
        const response = await this.$axios
          .get(
            "/Sale/GetSalesByCardNumber?cardNumber=" + this.employee.cardNumber
          )
          .then(response => {
            sales = response.data;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              } else if (error.response.status == 404) {
                alertify.error("Kişi Bulunamadı");
                this.clearEmployee();
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.clearEmployee();
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.clearEmployee();
                this.isLoading = false;
                return;
              }
            }
          });
        this.sales = sales;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error);
      }
    },
    toDateFormat(str, format) {
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye =
          str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    getDefaultDate() {
      let toDay = new Date();
      var gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
      var ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
      var yil = toDay.getFullYear();
      if (this.startDate == null) {
        this.startDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.endDate == null) {
        this.endDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    await this.getDefaultDate();
    $("body").addClass("sidebar-collapse");
  }
};
</script>
<style scoped>
.number-btn {
  border-radius: 30px;
  position: relative;
  padding: 15px 5px;
  min-width: 80px;
  text-align: center;
  color: #000000;
  border: 1px solid #ddd;
  background-color: #ffffff;
  font-weight: bold;
  font-size: 20px;
  width: 100%;
  margin: 0px 0px 10px 0px;
  height: 100px;
}
.reportHeadInfo {
  font-size: 14px;
  text-align: center;
  width: 100%;
  background: #00a0f0;
  color: #ffffff;
  padding: 5px;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/retailSale/retailSale.vue